import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-home',
  templateUrl: './contact-home.component.html',
  styleUrls: ['./contact-home.component.css']
})
export class ContactHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
